import Factory from "@/schemas/factory";

const schema = new Factory()
    .hasId()
    .make();

schema.prop('eventId').setType(Number);
schema.prop('personId').setType(Number);
schema.prop('association').setType(String);

export default schema;
